import { useCallback } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { type BlazeCommandLineProps } from 'components/BlazeCommandLine/Types'
import { AlmanacFile } from 'types'
import { Wizards } from 'components/Wizards/Wizards'

export const useNewEntrypointModal = () => {
  const { openModal } = useModals()

  const openWizard = useCallback(
    (props?: BlazeCommandLineProps) => {
      openModal(Wizards, {
        initialValues: { project: props?.createInFolder as AlmanacFile },
      })
    },
    [openModal],
  )

  return {
    openNewEntrypointModal: openWizard,
  }
}

export default useNewEntrypointModal
